import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recurring-orders',
  templateUrl: './recurring-orders.component.html',
  styleUrls: ['./recurring-orders.component.scss']
})
export class RecurringOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
